// extracted by mini-css-extract-plugin
module.exports = {"numberInput":"number-input_numberInput__8cwm6","input":"number-input_input__qiEUW","decrement":"number-input_decrement__1RXJT","increment":"number-input_increment__OPKgf"};